import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { setShowAuthenticationPopup } from "../../redux/slices/globalSlice";
import { login } from "../../redux/slices/userSlice";
import { ThreeDots } from "react-loader-spinner";
import "./Login.css";
import { useHistory, useLocation } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const closeAuthenticationPopup = () => {
    dispatch(setShowAuthenticationPopup(false));
    if (location.pathname === "/dashboard") {
      history.goBack();
    }
  }
  const submitLoginForm = () => {
    setErrors([]);
    let errors = [];
    if (
      email.trim() === "" ||
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        email
      ) === false
    ) {
      errors.push(t("AUTH_EMAIL_ERROR"));
    }
    if (password.trim() === "") {
      errors.push(t("AUTH_PASSWORD_ERROR"));
    }
    if (errors.length === 0) {
      setShowLoader(true);
      dispatch(login(email, password)).then((result) => {
        setShowLoader(false);
        if (result === "") {
          dispatch(setShowAuthenticationPopup(false));
        } else {
          switch (result) {
            case 'auth/invalid-email':
              errors.push(t("AUTH_EMAIL_ERROR"));
              break;
            case 'auth/user-not-found':
              errors.push(t("AUTH_USER_NOT_FOUND_ERROR"));
              break;
            case 'auth/wrong-password':
              errors.push(t("AUTH_WRONG_PASSWORD"));
              break;
            default:
              errors.push(t("GLOBAL_ERROR"));
              break;
          }
          setErrors(errors);
        }
      });
    } else {
      setErrors(errors);
    }
  };

  return (
    <div className="containter">
      <h1>{t("AUTH_LOGIN")}</h1>
      <Form>
        <Form.Group>
          <Form.Label>{t("AUTH_EMAIL")}</Form.Label>
          <Form.Control
            type="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </Form.Group>
        <Form.Group>
          <Form.Label>{t("AUTH_PASSWORD")}</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </Form.Group>
        {errors.length > 0 && (
          <Alert variant="danger">
            {errors.map((error) => {
              return <p>{error}</p>;
            })}
          </Alert>
        )}
        <div className="row">
          <div className="col-sm">
            <Button
              style={{ width: "150px" }}
              variant="primary"
              type="button"
              onClick={() => {
                submitLoginForm();
              }}
            >
              {showLoader && (
                <ThreeDots color="#FFFFFF" height={20} width={50} />
              )}
              {!showLoader && <span>{t("AUTH_LOGIN_SUBMIT")}</span>}
            </Button>
          </div>
          <div className="col-sm">
            <Button
              className="float-right"
              style={{ width: "150px" }}
              variant="secondary"
              type="button"
              onClick={() => {
                closeAuthenticationPopup();
              }}
            >
              {t("GLOBAL_CLOSE")}
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
};

export default Login;
